import * as React from "react";
import gql from "graphql-tag";
import UserDetailTopBar from "./Ops.Users.UserDetailTopBar";
import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";

import {
  LinkUsersAndDevicesTable,
  fragments,
} from "app/components/AppComponents/Fraud";
import { graphql } from "react-apollo";

type Props = {
  error: any;
  data: {
    user: { email: string; linked_users: any[] };
    refetch: any;
    loading: boolean;
  };
  match: any;
  setHeader: (data: { title: string; description: string }) => void;
  query: any;
};

class LinkedUsers extends React.Component<Props, {}> {
  render() {
    const { linked_users } = this.props.data.user || {
      linked_users: [],
    };

    return (
      <React.Fragment>
        <UserDetailTopBar />
        <section className="padded">
          <BOGraphQLLoader {...this.props}>
            <LinkUsersAndDevicesTable linkedUsers={linked_users} />
          </BOGraphQLLoader>
        </section>
      </React.Fragment>
    );
  }
}

const linkedUsersQuery = gql`
  ${fragments.linkedUserParts}
  ${fragments.fraudCommentsParts}

  query LinkedUsers($external_reference: ID!) {
    user(external_reference: $external_reference) {
      email
      linked_users {
        ...LinkedUserParts
        devices {
          ...FraudCommentsParts
        }
      }
    }
  }
`;

const LinkedUsersWithData = graphql(linkedUsersQuery, {
  options(props: any) {
    return {
      fetchPolicy: "network-only",
      variables: {
        external_reference: props.match.params.id,
      },
    };
  },
})(LinkedUsers);
export default LinkedUsersWithData;
